import React, { useEffect } from 'react';


import Announcements from './Announcements';
import { useAnnouncements } from '../../../../hooks';

function AnnouncementsContainer() {

    const { announcements, getAnnouncements } = useAnnouncements();

    useEffect(() => {
        getAnnouncements();
    }, []);

    if (!announcements || (announcements && announcements.length < 1)) {
        return null;
    }

    return (
        <div className="announcements">
            <Announcements {...{ announcements }} />
        </div>
    );
}

export default AnnouncementsContainer;